export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    // Use 'common' to allow any Microsoft account (work, school, or personal)
    // Use 'organizations' to allow any work/school account
    // Use 'consumers' to allow only personal Microsoft accounts
    // Use specific tenant ID to restrict to one organization only
    authority: `https://login.microsoftonline.com/common`,
    redirectUri:
      process.env.REACT_APP_AZURE_REDIRECT_PATH || window.location.origin,
    postLogoutRedirectUri:
      process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            return;
          case 1: // Warning
            console.warn(message);
            return;
          case 2: // Info
            console.info(message);
            return;
          case 3: // Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const tokenRequest = {
  scopes: ["User.Read"],
  forceRefresh: false,
};
